import { useEffect, useState, type FC } from 'react';
import styles from './index.module.scss';
import { usePumpTradePresent } from '@hooks/use-pump-trade';
import type { OpenapiClientPump } from 'src/openapi/pump';
import { Link } from 'react-router-dom';
import { bigNumberToReadable } from '@utils/big-number-to-readable';
import Avatar from '@components/avatar';
import graduatedcatIcon from '@assets/images/pump/graduatecar.svg';
import graduatedLeftIcon from '@assets/images/pump/graduated-left.svg';
import graduatedRightIcon from '@assets/images/pump/graduated-right.svg';
export const NewTrade: FC = () => {
  const present = usePumpTradePresent();
  const [_, setCacheData] = useState<OpenapiClientPump.GetTradeTopEventsResponse>([]);

  const [showData, setShowData] = useState<OpenapiClientPump.GetTradeTopEventsResponse>([]);
  const [removingIds, setRemovingIds] = useState<string[]>([]);

  useEffect(() => {
    if (present.length > 0) {
      setCacheData((pre) => [...pre, ...present]);
    }
  }, [JSON.stringify(present)]);

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;
    const loop = () => {
      let cache: OpenapiClientPump.GetTradeTopEventsResponse[number];
      setCacheData((pre) => {
        if (pre.length < 1) {
          return pre;
        }
        cache = pre[0]!;
        return pre.slice(1);
      });
      setShowData((pre) => {
        if (cache) {
          return [...pre, cache];
        }
        return pre;
      });
      timer = setTimeout(() => {
        loop();
      }, 1000 * 4);
    };
    loop();
    return () => {
      clearTimeout(timer);
    };
  }, []);

  const removeData = (digest: string) => {
    setRemovingIds((pre) => [...pre, digest]);
  };

  if (showData.length < 1) return null;

  return (
    <>
      {showData.map((item, index) => {
        return removingIds.includes(item.tx_digest) ? null : (
          <List data={item} key={index + item.tx_digest} index={index} removeData={removeData} />
        );
      })}
    </>
  );
};

const List: FC<{
  data: OpenapiClientPump.GetTradeTopEventsResponse[number];
  index: number;
  removeData(digest: string): void;
}> = ({ data, index, removeData }) => {
  const [isHover, setIsHover] = useState(false);
  useEffect(() => {
    if (isHover) {
      return;
    }
    let timer: NodeJS.Timeout | undefined;
    timer = setTimeout(() => {
      removeData(data.tx_digest);
    }, 45000);
    return () => {
      clearTimeout(timer);
    };
  }, [data.tx_digest, isHover]);

  if (data.type === 'pool-created') {
    return (
      <Link
        to={`/fun/${data.token_address}`}
        className={styles.new_trade}
        style={{ top: index % 2 === 0 ? '160px' : '220px' }}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
      >
        <div className={styles.items} key={data.tx_digest}>
          <Avatar address={data.sender} />
          {data.sender.slice(data.sender.length - 8)}
          <div className={styles.created}>Created</div>
          <img src={data.token_metadata?.iconUrl || ''} />
          {data.token_metadata.symbol}
        </div>
      </Link>
    );
  }

  if (data.type === 'pool-completed') {
    return (
      <Link
        to={`/fun/${data.token_address}`}
        className={styles.new_trade}
        style={{ top: index % 2 === 0 ? '160px' : '220px' }}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
      >
        <img src={graduatedcatIcon} className={styles.car} />
        <div className={styles.con}>
          <img src={graduatedLeftIcon} />
          <div className={styles.list} key={data.tx_digest}>
            <img src={data.token_metadata?.iconUrl || ''} />
            <div className={styles.graduated_symbol}>{data.token_metadata.symbol}</div>
            <div className={styles.graduated}>Graduated!</div>
          </div>
          <img src={graduatedRightIcon} />
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/fun/${data.token_address}`}
      className={styles.new_trade}
      style={{ top: index % 2 === 0 ? '160px' : '220px' }}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className={styles.items} key={data.tx_digest}>
        <Avatar address={data.sender} />
        {data.sender.slice(data.sender.length - 8)}
        <div className={`${styles.buy} ${data.is_buy ? '' : styles.sold}`}>
          {data.is_buy ? 'Bought' : 'Sold'}
        </div>
        <span>{bigNumberToReadable(data.sui_amount, 0, true)} SUI of</span>
        <img src={data.token_metadata?.iconUrl || ''} />
        {data.token_metadata.symbol}
      </div>
    </Link>
  );
};

export default NewTrade;
